module.exports = __webpack_public_path__ + "static/img/check-red.43fb239d.svg";